// The rolling-green-hill-under-a-blue-sky Windows desktop backdrop — a
// minimalist flat-illustration wallpaper (xpwallpaper.jpg in /public), a
// stylized reinterpretation rather than the copyrighted Microsoft photo.
// Shared by the landing hero, PublicCreatorPage (the real "windows98" links
// theme), and CreateDashboardPage's LivePreview (the theme-picker preview),
// so all three stay in sync from one source. objectPosition lets a caller
// bias which part of the scene stays visible when the container crops it
// (default centered); PUBLIC_URL keeps the path correct under /staging too.
const Windows98SkyBackground = ({
  className = 'fixed inset-0 z-0 w-full h-full',
  objectPosition = 'center',
}) => (
  <img
    src={`${process.env.PUBLIC_URL || ''}/xpwallpaper.jpg`}
    alt=""
    aria-hidden="true"
    className={className}
    style={{ objectFit: 'cover', objectPosition }}
  />
);

export default Windows98SkyBackground;
